import { useQuery } from "react-query";
import { API_BASE } from "../../constants/constants";
import { ReferenceDataApi } from "@iliotech/generated-api-v3";

export const useAvailableBenchmarks = () => {
  const api = new ReferenceDataApi(undefined, `${API_BASE}/api`);
  return useQuery(`available-benchmarks`, () => api.getIndexes());
};
